import api from '../../../api';
// import {api} from '../../../api';

export const getChart = (credentials, type, project) => {
  return api.post('persistence/sfdc/'+project+'/execution/results/'+type, credentials);
};

export const getProject = (credentials) => {
  return api.get('persistence/sfdc/get/collections', credentials);
};

export const getSuitType = (credentials) => {
  return api.get('persistence/sfdc/'+credentials+'/suitetype/get');
};

export const getTestCases = (credentials, project) => {
  return api.get('persistence/sfdc/'+project+'/get-failed-testcases', {params:credentials});
};


export const getDashboard = (credentials) => {
  return api.post('persistence/sfdc/get-with-fields', credentials);
};

export const getPiechartBulk = (credentials) => {
  return api.post('persistence/sfdc/execution-results/piechart-bulk', credentials);
};
export const getBulkData = (credentials) => {
  return api.post('persistence/sfdc/execution-results/bulk', credentials);
};
export const getTrendchartBulk = (credentials) => {
  return api.post('persistence/sfdc/execution-results/trendchart-bulk', credentials);
};

export const getuserInfomation = () => {
  return api.get('authentication/jwt/user/get');
};

export const selectDefaultProject = (credentials) => {
  return api.post('authentication/jwt/user/update', credentials);
};

//http://apttusautomation01.apttuscloud.io:9089/persistence/clm/fetch-analytics-data?runId=1609151922000
export const fetchAnalyticsData = (credentials, project) => {
  // window.api.defaults.baseURL =  "http://apttusautomation01.apttuscloud.io:9088/";
  return api.get('persistence/'+project+'/automation-analytics/fetch-analytics-data',{params: credentials});
};

// http://apttusautomation01.apttuscloud.io:9089/persistence/clm/automation-analytics/create
export const automationAnalyticsCreate = (credentials, project) => {
  return api.post('persistence/'+project+'/automation-analytics/create', credentials);
};